import React, { memo } from 'react';
import { convertSecondsToTimeString } from '@goldcast/player-config/src/utils/timeUtils';
import { useRemotionPlayerCurrentTime } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerCurrentTime';
import useRemotionPlayerDuration from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerDuration';

function PlayerTime() {
  const { currentTime } = useRemotionPlayerCurrentTime();
  const fullDuration = useRemotionPlayerDuration();
  const totalTimeWithFormat = convertSecondsToTimeString(fullDuration || 0, 'HH:mm:ss');
  const currentTimeWithFormat = convertSecondsToTimeString(Math.min(currentTime || 0), 'HH:mm:ss');

  return (
    <div className="flex select-none items-center gap-2 tabular-nums">
      <div>{currentTimeWithFormat}</div>
      <div className="text-slate-500">/</div>
      <div className="text-slate-500" data-testid="timeline-total-video-time">
        {totalTimeWithFormat}
      </div>
    </div>
  );
}
export default memo(PlayerTime);
